import { render, staticRenderFns } from "./BottomNavigationMenu.vue?vue&type=template&id=7cfb01a4&scoped=true&"
import script from "./BottomNavigationMenu.vue?vue&type=script&lang=js&"
export * from "./BottomNavigationMenu.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavigationMenu.vue?vue&type=style&index=0&id=7cfb01a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfb01a4",
  null
  
)

export default component.exports